$ = require("jquery");
require("jquery-jpostal-ja");

$(() => {
  calcPrice();
});

$(() =>
  $("#order_postcode").jpostal({
    postcode : [ "#order_postcode" ],
    address  : {
      "#order_prefecture_code" : "%3",
      "#order_address_1" : "%4%5",
      "#order_address_2" : "%6%7"
    }
  })
);

$(() =>
  $("#user_postcode").jpostal({
    postcode : [ "#user_postcode" ],
    address  : {
      "#user_prefecture_code" : "%3",
      "#user_address_1" : "%4%5",
      "#user_address_2" : "%6%7"
    }
  })
);

$(() =>
  $("#order_ship_postcode").jpostal({
    postcode : [ "#order_ship_postcode" ],
    address  : {
      "#order_ship_prefecture_code" : "%3",
      "#order_ship_address_1" : "%4%5",
      "#order_ship_address_2" : "%6%7"
    }
  })
);

$(() =>
  $(".group_order_number").change(function() {
    // 値があればハイライト、なければ解除
    if ($(this).val()) {
      $(this).addClass("is-filled");
    } else {
      $(this).removeClass("is-filled");
    }
    $("#order_number_serial_100").valid();
    calcPrice();
  })
);
$(() => 
  $("#order_point_used").change(() => {
    calcPrice();
  })
);

$(() =>
  $(".premium_recommend_card").click(function(e) {
    e.preventDefault();
    // 選択状態の切り替え
    $(".premium_recommend_card").removeClass("is-selected");
    $(this).addClass("is-selected");
    // 既存のハイライトをクリア
    $(".group_order_number").removeClass("is-filled");
    // 全セレクトをリセット
    $(".group_order_number").each(function() {
      $(this).val("");
    });
    // data-selectionsの値をセット
    var selections = $(this).data("selections");
    $.each(selections, function(id, val) {
      $("#" + id).val(val).addClass("is-filled");
    });
    // バリデーション＋料金計算
    $("#order_number_serial_100").valid();
    calcPrice();
    // 最初に値がセットされたセレクトまでスクロール
    var firstId = Object.keys(selections)[0];
    var $target = $("#" + firstId);
    if ($target.length) {
      $("html, body").animate({
        scrollTop: $target.offset().top - 100
      }, 400);
    }
  })
);

const getVal = (id) => {
  var el = $(id);
  return el.length ? Number(el.has("option:selected").val()) : 0;
};

const calcPrice = () => {
  normal_mini_sum = getVal("#order_number_serial_100") +
    getVal("#order_number_serial_10") +
    getVal("#order_number_fukuren") +
    getVal("#order_number_random_100") +
    getVal("#order_number_random_10") +
    getVal("#order_number_3renbara") +
    getVal("#order_number_fukubara") +
    getVal("#order_number_fukubara_1000") +
    getVal("#order_number_mini_serial_100") +
    getVal("#order_number_mini_serial_10") +
    getVal("#order_number_mini_fukuren") +
    getVal("#order_number_mini_random_100") +
    getVal("#order_number_mini_random_10") +
    getVal("#order_number_mini_3renbara") +
    getVal("#order_number_mini_fukubara") +
    getVal("#order_number_mini_fukubara_1000")

  premium_sum = getVal("#order_number_premium_serial_100") +
    getVal("#order_number_premium_serial_10") +
    getVal("#order_number_premium_fukuren") +
    getVal("#order_number_premium_random_100") +
    getVal("#order_number_premium_random_10") +
    getVal("#order_number_premium_3renbara") +
    getVal("#order_number_premium_fukubara") +
    getVal("#order_number_premium_fukubara_1000")

  point_used = Number($("#order_point_used").val())

  $('#point_used').html(point_used)

  $.get({
    url: "/orders/calc",
    data: {
      normal_mini_number: normal_mini_sum,
      premium_number: premium_sum,
      point_used: point_used
    }
  })
};
